export var decodeJWTTokenPayload=function(token){return JSON.parse(atob(token.split(".")[1]))};